import { format as formatDate } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';

export enum CompareTypes {
    BiggerThan,
    BiggerThanOrEqualTo,
    SmallerThan,
    SmallerThanOrEqualTo
}

export enum ManipulationTypes {
    Add,
    Subtract
}

export default class DateHelper {

    static DDMMMYYYY = 'dd-MMM-yyyy';
    static DDMMYYYY = 'dd-MM-yyyy';
    static YYYYMMDD = 'yyyy-MM-dd';
    static DATE_PICKER_FORMATS: string[] = ['DD-MMM-YYYY', 'DD-MM-YYYY', 'DDMMYYYY'];
    static DATE_PICKER_FORMATS_ISO: [string, string] = ['YYYY-MM-DD', 'DDMMYYYY'];

    static ToDate = (date: Date | string | undefined) : Date => {
        if (date === undefined || date === null) {
            return new Date("0001-01-01T00:00:00");
        }

        if (date instanceof Date) {
            return date;
        }

        if (typeof date === 'string') {
            return new Date(date);
        }

        if(dayjs.isDayjs(date)) {
            return (date as Dayjs).toDate();
        }

        // Assume it's an object with year, month, day
        return new Date((date as any).year, (date as any).month - 1, (date as any).day);
    }


    static ToDateString = (date: Date | string | undefined, format:string = DateHelper.DDMMMYYYY) : string => {
        //return (date) ? ((date as Date as Date) ? formatDate(date, format) : formatDate(new Date(date), format)) : '';
        //return (date) ? formatDate(new Date(date), format) : '';
        
        if(!date)
            return '';

        let newDate = this.ToDate(date);
        let defaultDate = new Date("0001-01-01T00:00:00");

        return (newDate.toISOString() === defaultDate.toISOString()) ? '' : formatDate(newDate, format);
    }

    static ToDayJS = (date: Date | string | undefined):dayjs.Dayjs => {
        const newDate = this.ToDate(date);
        return dayjs(newDate);
    }

    static CompareDates = (dateA: string|Date, dateB: string|Date, compareType: CompareTypes) : boolean => {
        if(!dateA || dateA === '' || !dateB || dateB === '')
            return false;

        let dateATime = new Date(dateA).getTime();
        let dateBTime = new Date(dateB).getTime();

        switch(compareType)
        {
            case CompareTypes.BiggerThan:
                return (dateATime > dateBTime);
            case CompareTypes.BiggerThanOrEqualTo:
                return dateATime >= dateBTime;
            case CompareTypes.SmallerThan:
                return dateATime < dateBTime;
            case CompareTypes.SmallerThanOrEqualTo:
                return dateATime <= dateBTime;
            default:
                return false;
        }
    }

    static CompareDates_Between = (date: string|Date, minDate: string|Date, maxDate: string|Date, equalsTo: boolean = true) : boolean => {
        if(!date || date === '' || !minDate || minDate === '' || !maxDate || maxDate === '')
            return false;

        return (equalsTo)
            ? date >= minDate && date <= maxDate
            : date > minDate && date < maxDate;
    }

    static DateManipulation = (dateA: string|Date, dateB: string|Date, manipulationType: ManipulationTypes) : any => {
        if(!dateA || dateA === '' || !dateB || dateB === '')
            throw new Error("Dates cannot be empty!");
        
        let dateATime = new Date(dateA).getTime();
        let dateBTime = new Date(dateB).getTime();

        switch(manipulationType)
        {
            case ManipulationTypes.Add:
                return dateATime + dateBTime;
            case ManipulationTypes.Subtract:
                return dateATime - dateBTime;
            default:
                throw new Error("Manipulation type not supported!");
        }
    }
}